import React, { useRef } from 'react';
import SearchConditionStyled from './SearchConditionStyled';
import { useForm, Controller } from 'react-hook-form';
import {
  Box,
  FormControl,
  // MenuItem,
  // Select,
  // InputLabel,
  TextField,
  Button,
  useTheme,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';

const SearchCondition = (props) => {
  // const dispatch = useDispatch();
  // const { query } = props;
  const { handleSearch, restClick } = props;
  // const { label } = query;
  const theme = useTheme();
  const searchRef = useRef();
  const {
    handleSubmit,
    control,
    // reset,
    setValue,
    // getValues,
    watch,
  } = useForm({
    defaultValues: {
      // label,
    },
  });

  const watchLabel = watch('label');

  //点击重置
  const resetData = () => {
    setValue('label', '');
    const propsResetSearch = {
      label: '',
    };
    restClick && restClick(propsResetSearch);
  };

  //查询
  const handleSubmitSuccess = (submitData) => {
    const propsSubmitData = {
      ...submitData,
    };
    window.NE_DAWN.trigger(searchRef.current, {
      event: '_ec', // 事件名
      params: { ...submitData }, // 事件公参
    });
    handleSearch && handleSearch(propsSubmitData);
  };

  return (
    <SearchConditionStyled theme={theme}>
      <form onSubmit={handleSubmit(handleSubmitSuccess)}>
        {/* 创建标签 */}

        <div className="search-content-wrap">
          <Box className="search-content-content">
            <FormControl className="label-content">
              <Controller
                as={
                  <TextField
                    control={control}
                    id="basic"
                    className="single-select"
                    label="标签"
                    // defaultValue={''}
                    // value={title}
                    variant="standard"
                    placeholder="请输入标签名"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              resetData();
                            }}
                            edge="end"
                          >
                            {watchLabel && <ClearIcon className="clear-icon" />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                }
                control={control}
                name="label"
                placeholder="请输入标签名"
                rules={{
                  required: true,
                }}
              />
            </FormControl>
            <Button
              data-log={JSON.stringify({
                oid: 'btn_user_profile_label_management_list_search',
                events: ['_ev'],
                params: {
                  initUrl: window.location.origin + window.location.pathname,
                },
              })}
              ref={searchRef}
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '24px', height: '24px' }} />}
            ></Button>
          </Box>

          {/* 按钮 */}
          {/* <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              type="reset"
              className="reset"
              onClick={() => resetData()}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>
            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box> */}
        </div>
      </form>
    </SearchConditionStyled>
  );
};

export default SearchCondition;
